import React from 'react';
import cx from 'classnames';

import CheckmarkListItem, {
  CheckmarkListItemProps,
} from '../CheckmarkListItem';
import PriceBlock, { PriceBlockProps } from '../PriceBlock';

import { Heading5, Tag } from '../Typography';

import styles from './index.module.scss';

export interface PriceBlockWithTextCardProps {
  title: string;
  label?: string;
  listItems?: CheckmarkListItemProps[];
  priceBlock: PriceBlockProps;
}

const PriceBlockWithTextCard: React.FC<PriceBlockWithTextCardProps> = ({
  title,
  label,
  listItems,
  priceBlock,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.textBlock}>
        <Heading5 className={styles.title}>{title}</Heading5>

        <div className={styles.labelAndListWrapper}>
          {label && <Tag className={styles.label}>{label}</Tag>}

          {listItems && listItems.length > 0 && (
            <ul
              className={cx(styles.list, {
                [styles.withoutLabelOnDesktop]: !label,
              })}
            >
              {listItems.map((item, index) => (
                <CheckmarkListItem key={index} {...item} />
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className={styles.priceBlock}>
        <PriceBlock {...priceBlock} />
      </div>
    </div>
  );
};

export default PriceBlockWithTextCard;
